import { Component } from '@angular/core';

import { AuthService } from './shared/auth.service';
import { environment } from 'src/environments/environment';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent {
  public version: string;
  public buildDate: string;

  constructor(
    private readonly authService: AuthService,
    private readonly datePipe: DatePipe) {
      this.version = environment.gitVersion.version;
      try {
        this.buildDate = this.datePipe.transform(environment.gitVersion.buildDate, 'dd.MM.yyyy');
      }
      catch (e) {
        this.buildDate = environment.gitVersion.buildDate;
      }
  }

  public logout(): void {
    this.authService.logout();
  }
}
